import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daohang",
  "use": "icon-daohang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-daohang\"><defs><style></style></defs><path d=\"M605.848 958.709a21.13 21.13 0 0 1-20.377-15.523L476.9 548.458 80.07 437.835a21.125 21.125 0 1 1-1.985-40.039L929.25 66.729A21.125 21.125 0 0 1 956.6 94.077L625.532 945.24a21.128 21.128 0 0 1-19.684 13.468zm-453.31-544.536l347.231 96.797a21.132 21.132 0 0 1 14.697 14.746l94.822 344.73 290.526-746.93-747.277 290.657z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol